"use strict";
var React = require("react");
var ReactDOM = require('react-dom');
var InventoryActions = require("../../actions/InventoryActions")
var InventoryStore = require("../../stores/InventoryStore");
var EquipmentListFilter = require("./EquipmentListFilter.react");
var AuthStore = require("../../stores/AuthenticationStore");
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');
// ==========
// SUB HEADER
// ==========

var SubHeader = React.createClass({
    getInitialState: function(){
        var currentQuery = InventoryStore.getState().filterData.query;
        var showClear = false;
        if(currentQuery != ''){
            showClear = true;
        }
        return {
            showClear: showClear,
            showSearch: false,
            currentQuery: currentQuery
        };
    },
    filterEquipment: function() {
      // Submits a search / filter query to the server.
      var data = InventoryStore.getState().filterData;
      data.query = ReactDOM.findDOMNode(this.refs.filterEquipment).value;
      data.account = AuthStore.getState().account;
      data.owner = AuthStore.getState().id;

      InventoryActions.filterEquipment(data);
      this.setState({showClear: true, showSearch:false});
    },
    clearFilter: function(){
        var data = InventoryStore.getState().filterData;
        data.query = "";
        data.account = AuthStore.getState().account;
        data.owner = AuthStore.getState().id;

        InventoryActions.filterEquipment(data);
        ReactDOM.findDOMNode(this.refs.filterEquipment).value = "";
        ReactDOM.findDOMNode(this.refs.filterEquipment).focus();
        this.setState({showClear: false, showSearch:false});
    },
    _handleKeyPress: function(e){
        var value = ReactDOM.findDOMNode(this.refs.filterEquipment).value;
        if (value != '') {
          if (e.key === 'Enter') {
            this.filterEquipment();
            this.setState({ showClear: true, showSearch: false});
          } else if (e.key === 'Escape'){
            this.clearFilter();
            this.setState({ showClear: false, showSearch: false});
          } else {
            this.setState({ showClear: false, showSearch: true});
          }
        } else {
          this.clearFilter();
          this.setState({showClear: false, showSearch: false});
        }
    },
    render: function(){
        return(
            <div id="subheader">
              <span className="glyphicon glyphicon-search search-icon"></span>
              <input
                id="inventorySearch"
                ref="filterEquipment"
                className="input search-input"
                type="text"
                defaultValue={this.state.currentQuery}
                placeholder="Leita..."
                onKeyUp={this._handleKeyPress}
                autoComplete="off"
              />
              <EquipmentListFilter isMarket={this.props.isMarket} updateFilter={this.props.updateFilter} />
              {(this.state.showSearch) &&
                <button
                  id="filterEquipment"
                  className="btn btn-blue btn-flat btn-xs"
                  type="button"
                  title="Leita"
                  onClick={this.filterEquipment}
                >
                    Leita
                </button>
              }
            </div>
        );
    }
});

module.exports = SubHeader;



// WEBPACK FOOTER //
// ./app/scripts/ui/Inventory/InventorySubHeader.react.js